import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import { getCookie } from "../../utils/common";
import * as actions from "../../actions/index";
import { useRef } from "react";

const FullPageLoader = dynamic(() => import('../../components/FullPageLoader/FullPageLoader'));
const Blog = dynamic(() => import('../../components/blog/blog'));
const BlogDetails = dynamic(() => import('../../components/blog-details/blog-details'));
const HocHead = dynamic(() => import('../HigherOrderComponent/HocHead'));
const SubscribeBlogsModal = dynamic(() => import('../modals/SubscribeBlogsModal'));

const BlogPage = (props) => {
	const slug = props.slug;
	const loading = useSelector(state => state.loaderReducer.loading);
	const dispatch = useDispatch();
	const [showSubscribeModal, setShowSubscribeModal] = useState(false);
	const modalOpenTimeRef = useRef(null);

	const sdata = props.data;
	const data = sdata.data[0].attributes;
	const seo = sdata.data[0].attributes.seo ?? [];
	const blocks = sdata.data[0].attributes.blocks;

	useEffect(() => {
		dispatch(actions.hideLoader());
	}, [dispatch]);

	useEffect(() => {
		const subscriptionModalClosedOnce = getCookie('SubscriptionModalClosedOnce');
		if (!subscriptionModalClosedOnce) {
			if (modalOpenTimeRef?.current) {
				clearTimeout(modalOpenTimeRef.current);
			}
			modalOpenTimeRef.current = setTimeout(() => {
				setShowSubscribeModal(true);
			}, 25000);
		}
	}, []);

	const MemoizedBlog = useMemo(() => <Blog blocks={blocks} slug={data.slug} />, [blocks, data.slug]);
	const MemoizedBlogDetails = useMemo(() => <BlogDetails blocks={data} />, [data]);

	console.log('data', data)
	return (
		<>

			{seo && (
				<HocHead seo={seo}>
					<meta data-head="tezjs" property="article:published_time" content={data.publish_at} />
					<meta data-head="tezjs" property="article:modified_time" content={data.updatedAt} />
					<meta data-head="tezjs" property="og:type" content="article" />
					<meta data-head="tezjs" property="og:locale" content="en_US" />
					<meta data-head="tezjs" property="og:site_name" content="TRooTech" />
					<meta data-head="tezjs" property="og:image:width" content="788" />
					<meta data-head="tezjs" property="og:image:height" content="414" />
				</HocHead>
			)}

			{data.slug === "blog" ? MemoizedBlog : MemoizedBlogDetails}
			{showSubscribeModal && (
				<SubscribeBlogsModal
					show={showSubscribeModal}
					hide={() => {
						setShowSubscribeModal(false);
						document.cookie = "SubscriptionModalClosedOnce=true";
					}}
				/>
			)}
		</>
	);
};

export default BlogPage;
